module.exports = __webpack_public_path__ + "img/coins.4a98135c.svg";